// src/components/DigitalRoadmap.jsx
import React from "react";
import { Container } from "react-bootstrap";
import {
  FaCogs,
  FaBullseye,
  FaTasks,
  FaUsers,
  FaServer,
  FaExchangeAlt,
  FaClipboardList,
  FaChartLine,
  FaProjectDiagram,
  FaUsersCog,
  FaRobot,
  FaGlobe,
} from "react-icons/fa";

import "./DigitalRoadmap.css";

const steps = [
 { step: "Step 1", title: "Digital Organisational Assessment", icon: <FaCogs />, pos: { left: "5%", top: "100px" } },
{ step: "Step 2", title: "Objectives and Goals", icon: <FaBullseye />, pos: { left: "13%", top: "-26px" } },
{ step: "Step 3", title: "Prioritisation of Initiatives", icon: <FaTasks />, pos: { left: "21%", top: "120px" } },
{ step: "Step 4", title: "Building Cross-Functional Teams", icon: <FaUsers />, pos: { left: "30%", top: "-39px" } },
{ step: "Step 5", title: "Scaling Technology Infrastructure", icon: <FaServer />, pos: { left: "38%", top: "121px" } },
{ step: "Step 6", title: "Applying Change Management", icon: <FaExchangeAlt />, pos: { left: "46%", top: "-26px" } },
{ step: "Step 7", title: "Develop Action Plan", icon: <FaClipboardList />, pos: { left: "54%", top: "120px" } },
{ step: "Step 8", title: "Define KPIs", icon: <FaChartLine />, pos: { left: "63%", top: "-10px" } },
{ step: "Step 9", title: "Invest in Project Management", icon: <FaProjectDiagram />, pos: { left: "70%", top: "120px" } },
{ step: "Step 10", title: "Continuous Training & Upskilling", icon: <FaUsersCog />, pos: { left: "78%", top: "-30px" } },
{ step: "Step 11", title: "AI & Automation Adoption", icon: <FaRobot />, pos: { left: "87%", top: "120px" } },
{ step: "Step 12", title: "Ongoing Performance Monitoring", icon: <FaGlobe />, pos: { left: "95%", top: "-46px" } },

];

const DigitalRoadmap = () => {
  return (
    <section className="roadmap-section py-5">
        <h2 className="fw-bold text-center mb-5">Our Digital Roadmap</h2>
      <Container className="position-relative">
        
         
        {/* Wavy Road SVG with 9 curves */}
        <svg
  className="roadmap-curve"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1800 200"
  preserveAspectRatio="none"
>
<path
            d="
              M0,100 
              C100,0 200,200 300,100
              C400,0 500,200 600,100
              C700,0 800,200 900,100
              C1000,0 1100,200 1200,100
              C1300,0 1400,200 1500,100
              C1600,0 1700,200 1800,100
            "
            stroke="#2d2d2d"
            strokeWidth="18"
            fill="transparent"
            strokeLinecap="round"
          />
</svg>


        {/* Steps */}
        <div className="roadmap-steps">
          {steps.map((item, index) => (
            <div
              className="roadmap-step"
              key={index}
              style={{ left: item.pos.left, top: item.pos.top }}
            >
              <div className="roadmap-icon">{item.icon}</div>
              <div className={`step-circle step-${index + 1}`}>
                <span>{item.step}</span>
              </div>
              <h6 className="mt-2">{item.title}</h6>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default DigitalRoadmap;
